import { render, staticRenderFns } from "./MicroLesson.vue?vue&type=template&id=7900d654&scoped=true"
import script from "./MicroLesson.vue?vue&type=script&lang=js"
export * from "./MicroLesson.vue?vue&type=script&lang=js"
import style0 from "./MicroLesson.vue?vue&type=style&index=0&id=7900d654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7900d654",
  null
  
)

export default component.exports